export class Data {
    data: object
}

export class UserData extends Data {
    type: string
    attributes: object
}

export class UserDataAttributes extends UserData {
    username: string;
    password: string;
    email: string;
    is_staff?: boolean;
    is_superuser?: boolean;
    role: string;
}
